const MuiFormHelperText = {
  styleOverrides: {
    root: {
      marginLeft: '2px',
      marginRight: '2px',
      marginTop: '0',
      fontSize: '16px'
    }
  }
};
export default MuiFormHelperText;